import Cookies from 'universal-cookie';

import { pushGtmEvent } from './gtm';

export type AuthMethod = 'KAKAO' | 'APPLE' | 'GOOGLE' | 'PHONE' | 'EMAIL';
export type AuthEvent = 'login' | 'sign_up';

const COOKIE_KEY = 'pendingAuthEvent';
const MAX_AGE = 60 * 30;

const cookies = new Cookies(null, { path: '/' });

interface PendingAuthEvent {
    event: AuthEvent;
    method: AuthMethod;
}

export function pushAuthEvent(event: AuthEvent, method: AuthMethod) {
    pushGtmEvent({ event, method });
}

/**
 * 본인인증(NICE) 리다이렉트 후 IdentifySuccessActivity 에서는 로그인·회원가입을 구분할 수 없어서,
 * 본인인증 요청 전에 이벤트 정보를 쿠키에 저장해 두었다가 인증 성공 후 발화한다.
 */
export function savePendingAuthEvent(event: AuthEvent, method: AuthMethod) {
    const data: PendingAuthEvent = { event, method };
    cookies.set(COOKIE_KEY, JSON.stringify(data), {
        maxAge: MAX_AGE,
        path: '/',
    });
}

/** 저장된 로그인·회원가입 이벤트를 1회 발화하고 삭제한다. */
export function pushPendingAuthEvent() {
    try {
        const raw = cookies.get(COOKIE_KEY, { doNotParse: true });
        if (!raw) return;
        cookies.remove(COOKIE_KEY, { path: '/' });
        const { event, method }: PendingAuthEvent = JSON.parse(raw);
        pushAuthEvent(event, method);
    } catch (e) {
        console.error(e);
    }
}
